import { Currency, CurrencyValues } from '@paladin-monorepo/common';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { cn } from '@/lib/utils';

const CURRENCY_LABELS: Record<Currency, string> = {
  [Currency.CZK]: 'CZK',
  [Currency.EUR]: 'EUR',
  [Currency.USD]: 'USD',
};

export interface CurrencySelectProps {
  value?: string;
  onValueChange?: (value: string) => void;
  disabled?: boolean;
  className?: string;
}

export function CurrencySelect({
  value,
  onValueChange,
  disabled,
  className,
}: CurrencySelectProps) {
  return (
    <Select
      value={value ?? ''}
      onValueChange={onValueChange}
      disabled={disabled}
    >
      <SelectTrigger className={cn('w-[100px]', className)}>
        <SelectValue placeholder="Currency" />
      </SelectTrigger>
      <SelectContent>
        {CurrencyValues.map((c) => (
          <SelectItem key={c} value={c}>
            {CURRENCY_LABELS[c]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
